import styled from '@emotion/styled'
import { Box, Chip, Typography, Button } from '@mui/material'
import { typography } from '@resiliatech/birdsong'
import { colors } from '../../../../Themes/Colors'

export const StatsContainer = styled(Box)`
  margin-bottom: 16px;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
`

export const StatsWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const StatsLabel = styled(Typography)`
  color: ${colors.mediumGrey};
  font-weight: 500;
  min-width: fit-content;
  ${typography.up1.regularSans}
`

export const JobStatsWrapper = styled(Box)`
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  flex: 1;
`

export const JobStatItem = styled(Box)<{ isLast: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  border-right: ${({ isLast }) => (isLast ? 'none' : '1px solid #e0e0e0')};
  padding-right: ${({ isLast }) => (isLast ? '0' : '24px')};
`

export const JobStatName = styled(Typography)`
  font-weight: 600;
  min-width: fit-content;
  color: #333;
  ${typography.up1.regularSans}
`

export const JobStatChips = styled(Box)`
  display: flex;
  gap: 4px;
  align-items: center;
`

export const StatChip = styled(Chip)`
  height: 20px;
  font-size: 0.7rem;

  &.MuiChip-outlined {
    border-color: #999;
  }
`

export const BackButton = styled(Button)`
  background-color: #6b46c1;
  color: white;
  text-transform: none;
  font-weight: 500;

  &:hover {
    background-color: #5a3aa7;
  }
`

export const ActionsContainer = styled(Box)`
  display: flex;
  gap: 16px;
`

export const StatusChip = styled(Chip)<{ status: string }>`
  ${({ status }) => {
    switch (status) {
      case 'PENDING':
        return ''
      case 'RUNNING':
        return ''
      case 'COMPLETED':
        return ''
      case 'FAILED':
        return ''
      default:
        return ''
    }
  }}
`

export const ErrorTooltip = styled.span`
  cursor: help;
`
